import React, { Component } from 'react';
import Lottie from 'react-lottie';
import animationData from '../../../assets/loadingAni.json'
class AnimationPage extends Component {
    render() {
        const defaultOptions = {
            loop: true,
            autoplay: true,
            animationData: animationData,
            renderer: 'svg'
        }
        return (
            <div style={{zIndex:"1"}}>
               <Lottie
                options={defaultOptions}
                height={100}
                width={100}
               />
            </div>
        )
    };  
}
export default AnimationPage;